__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/4c75d70/_next/";